import buildSelectMenuDefinition, {SelectMenuDefinition} from "./../../../../../../../utils/forms/models/grid-fields/select-menu-definition";
import buildGroupDefinition, {
    GroupDefinition
} from "./../../../../../../../utils/forms/models/grid-fields/group-definition";
import buildSwitchDefinition, {
    SwitchDefinition
} from "./../../../../../../../utils/forms/models/grid-fields/switch-definition";
import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import buildNumberInputDefinition, {
    NumberInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/number-input-definition";
import { FormDefinition } from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import { GROUP_TYPE } from "../../../../../reducers/editingConfiguration.reducer";
import buildTextAreaDefinition, {
    TextAreaDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-area-definition";
import buildBulletsSelectorDefinition, {
    BulletsSelectorDefinition
} from "../../../../../../../utils/forms/models/grid-fields/bullets-selector-definition";

export const MRCHAMPION_FORM_TYPE = "mrChampion";

export enum SCHEMA_NAMES {
    ID = "id",
    TERMINAL_GROUPS = "terminal_groups",
    GAME_GROUPS = "game_groups",
    GROUPS = "groups",
    INITIAL_VALUE = "initial_value",
    MAX_VALUE = "max_value",
    CONTRIBUTION = "contribution",
    MINIMUM_PLAYERS = "min_players",
    MINIMUM_SORT = "min_sort",
    MAXIMUM_SORT = "max_sort",
    WEIGHT_COIN_IN = "weight_coin_in",
    WEIGHT_TOTAL_BONUS_WIN = "weight_total_bonus_win",
    PERCENTAGE_TERMINAL = "percentage_terminal",
    HUNTER_DRAW_NO_WIN = "hunter_draw_no_win",
    TIME_CONTINUE_ELIGIBLE_GAME = "time_continue_eligible_game",
    TIME_CONTINUE_ELIGIBLE_BONUS = "time_continue_eligible_bonus",
    TIME_CONTINUE_ELIGIBLE_EXTRA = "time_continue_eligible_extra",
    SHOW_ELIGIBLE_BONUS_ICON = "show_eligible_bonus_icon",
    BONUS_ENABLE_SCREEN = "bonus_enable_screen",
    START_PERCENTAGE = "start_percentage",
    PRIZE_GOLD_VALUE = "prize_gold_value",
    PRIZE_SILVER_VALUE = "prize_silver_value",
    PRIZE_BRONZE_VALUE = "prize_bronze_value",
    PRIZE_GOLD_FREQUENCY = "prize_gold_frequency",
    PRIZE_SILVER_FREQUENCY = "prize_silver_frequency",
    PRIZE_BRONZE_FREQUENCY = "prize_bronze_frequency",
    NUMBER_ELIGIBLE_GAMES = "number_eligible_games",
    TIME_ELIGIBLE = "time_eligible",
    POP_TIME = "pop_time",
    MINIMUM_POP_TIME = "min_pop_time",
    TIME_WAIT_VIDEO = "time_wait_video",
    PRIZE_PARAMETERS_GROUP = "prize_parameters_group",
    TIME_PARAMETERS_GROUP = "time_parameters_group",
    SECURITY_PARAMETERS_GROUP = "security_parameters_group",
    PRESET = "preset",
    NOTICE_PERIOD = "notice_period",
    COUNT_DOWN_PERIOD = "count_down_period"
}

const ID: TextInputDefinition = buildTextInputDefinition({
    name: "id",
    id: "MrChampionID",
    label: "ID",
    placeholder: "ID",
    schemaName: SCHEMA_NAMES.ID
});

const TERMINAL_GROUPS: (
    items: { label: string | number; value: string | number }[],
    completeList: { label: string | number; value: string | number }[]
) => BulletsSelectorDefinition = (items, completeList) =>
    buildBulletsSelectorDefinition({
        name: "terminal_groups",
        id: "terminal_groups",
        label: "Groups",
        schemaName: SCHEMA_NAMES.TERMINAL_GROUPS,
        completeList,
        items
    });

const GAME_GROUPS: (
    items: { label: string | number; value: string | number }[],
    completeList: { label: string | number; value: string | number }[]
) => BulletsSelectorDefinition = (items, completeList) =>
    buildBulletsSelectorDefinition({
        name: "game_groups",
        id: "game_groups",
        label: "Groups",
        schemaName: SCHEMA_NAMES.GAME_GROUPS,
        completeList,
        items
    });

const INITIAL_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "initial_value",
    id: "initialValue",
    label: "Initial Value",
    placeholder: "Initial Value",
    schemaName: SCHEMA_NAMES.INITIAL_VALUE
});

const MAX_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_value",
    id: "max_value",
    placeholder: "Insert Max Value",
    label: "Maximum Value",
    schemaName: SCHEMA_NAMES.MAX_VALUE
});

const CONTRIBUTION: NumberInputDefinition = buildNumberInputDefinition({
    name: "contribution",
    id: "contrib",
    placeholder: "Insert Contribution",
    label: "Contribution",
    schemaName: SCHEMA_NAMES.CONTRIBUTION
});

const MINIMUM_PLAYERS: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_players",
    id: "minPlayers",
    label: "Min. Players",
    placeholder: "Min. Players",
    schemaName: SCHEMA_NAMES.MINIMUM_PLAYERS
});

const MINIMUM_SORT: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_sort",
    id: "minSort",
    label: "Min. Sort",
    placeholder: "Min. Sort",
    schemaName: SCHEMA_NAMES.MINIMUM_SORT
});

const MAXIMUM_SORT: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_sort",
    id: "maxSort",
    label: "Max. Sort",
    placeholder: "Max. Sort",
    schemaName: SCHEMA_NAMES.MAXIMUM_SORT
});

const WEIGHT_COIN_IN: NumberInputDefinition = buildNumberInputDefinition({
    name: "weight_coin_in",
    id: "weightCoinIn",
    label: "Weight Coin In",
    placeholder: "Weight Coin In",
    schemaName: SCHEMA_NAMES.WEIGHT_COIN_IN
});

const WEIGHT_TOTAL_BONUS_WIN: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "weight_total_bonus_win",
        id: "weightTotalBonusWin",
        label: "Weight Total Bonus Win",
        placeholder: "Weight Total Bonus Win",
        schemaName: SCHEMA_NAMES.WEIGHT_TOTAL_BONUS_WIN
    }
);

const PERCENTAGE_TERMINAL: NumberInputDefinition = buildNumberInputDefinition({
    name: "percentage_terminal",
    id: "percentageTerminal",
    label: "Percentage Terminal",
    placeholder: "Percentage Terminal",
    schemaName: SCHEMA_NAMES.PERCENTAGE_TERMINAL
});

const HUNTER_DRAW_NO_WIN: NumberInputDefinition = buildNumberInputDefinition({
    name: "hunter_draw_no_win",
    id: "hunterDrawNoWin",
    label: "Hunter Draw No Win",
    placeholder: "Hunter Draw No Win",
    schemaName: SCHEMA_NAMES.HUNTER_DRAW_NO_WIN
});

const TIME_CONTINUE_ELIGIBLE_GAME: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "time_continue_eligible_game",
        id: "timeContinueEligibleGame",
        label: "Time Continue Eligible Game",
        placeholder: "Time Continue Eligible Game",
        schemaName: SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_GAME
    }
);

const TIME_CONTINUE_ELIGIBLE_BONUS: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "time_continue_eligible_bonus",
        id: "timeContinueEligibleBonus",
        label: "Time Continue Eligible Bonus",
        placeholder: "Time Continue Eligible Bonus",
        schemaName: SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_BONUS
    }
);

const TIME_CONTINUE_ELIGIBLE_EXTRA: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "time_continue_eligible_extra",
        id: "timeContinueEligibleExtra",
        label: "Time Continue Eligible Extra",
        placeholder: "Time Continue Eligible Extra",
        schemaName: SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_EXTRA
    }
);

const SHOW_ELIGIBLE_BONUS_ICON: SwitchDefinition = buildSwitchDefinition({
    name: "show_eligible_bonus_icon",
    id: "PigBoomShowEligibleBonusIcon",
    label: "Show Eligible Bonus Icon",
    schemaName: SCHEMA_NAMES.SHOW_ELIGIBLE_BONUS_ICON
});

const BONUS_ENABLE_SCREEN: SwitchDefinition = buildSwitchDefinition({
    name: "bonus_enable_screen",
    id: "PigBoomBonusEnableScreen",
    label: "Toggle on Screen",
    schemaName: SCHEMA_NAMES.BONUS_ENABLE_SCREEN
});

const START_PERCENTAGE: NumberInputDefinition = buildNumberInputDefinition({
    name: "start_percentage",
    id: "startPercentage",
    label: "Start Percentage",
    placeholder: "Start Percentage",
    schemaName: SCHEMA_NAMES.START_PERCENTAGE
});

const PRIZE_GOLD_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "prize_gold_value",
    id: "prizeGoldValue",
    label: "Prize Gold Value",
    placeholder: "Prize Gold Value",
    schemaName: SCHEMA_NAMES.PRIZE_GOLD_VALUE
});

const PRIZE_SILVER_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "prize_silver_value",
    id: "prizeSilverValue",
    label: "Prize Silver Value",
    placeholder: "Prize Silver Value",
    schemaName: SCHEMA_NAMES.PRIZE_SILVER_VALUE
});

const PRIZE_BRONZE_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "prize_bronze_value",
    id: "prizeBronzeValue",
    label: "Prize Bronze Value",
    placeholder: "Prize Bronze Value",
    schemaName: SCHEMA_NAMES.PRIZE_BRONZE_VALUE
});

const PRIZE_GOLD_FREQUENCY: NumberInputDefinition = buildNumberInputDefinition({
    name: "prize_gold_frequency",
    id: "prizeGoldFrequency",
    label: "Prize Gold Freq.",
    placeholder: "Prize Gold Freq.",
    schemaName: SCHEMA_NAMES.PRIZE_GOLD_FREQUENCY
});

const PRIZE_SILVER_FREQUENCY: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "prize_silver_frequency",
        id: "prizeSilverFrequency",
        label: "Prize Silver Freq.",
        placeholder: "Prize Silver Freq.",
        schemaName: SCHEMA_NAMES.PRIZE_SILVER_FREQUENCY
    }
);

const PRIZE_BRONZE_FREQUENCY: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "prize_bronze_frequency",
        id: "prizeBronzeFrequency",
        label: "Prize Bronze Freq.",
        placeholder: "Prize Bronze Freq.",
        schemaName: SCHEMA_NAMES.PRIZE_BRONZE_FREQUENCY
    }
);

const NUMBER_ELIGIBLE_GAMES: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "number_eligible_games",
        id: "numberEligibleGames",
        label: "Number Eligible Games",
        placeholder: "Number Eligible Games",
        schemaName: SCHEMA_NAMES.NUMBER_ELIGIBLE_GAMES
    }
);

const TIME_ELIGIBLE: NumberInputDefinition = buildNumberInputDefinition({
    name: "time_eligible",
    id: "timeEligible",
    label: "Time Eligible",
    placeholder: "Time Eligible",
    schemaName: SCHEMA_NAMES.TIME_ELIGIBLE
});

const POP_TIME: NumberInputDefinition = buildNumberInputDefinition({
    name: "pop_time",
    id: "popTime",
    label: "Pop Time",
    placeholder: "Pop Time",
    schemaName: SCHEMA_NAMES.POP_TIME
});

const MINIMUM_POP_TIME: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_pop_time",
    id: "minPopTime",
    label: "Min Pop Time",
    placeholder: "Min Pop Time",
    schemaName: SCHEMA_NAMES.MINIMUM_POP_TIME
});

const TIME_WAIT_VIDEO: NumberInputDefinition = buildNumberInputDefinition({
    name: "time_wait_video",
    id: "timeWaitVideo",
    label: "Time Wait Video",
    placeholder: "Time Wait Video",
    schemaName: SCHEMA_NAMES.TIME_WAIT_VIDEO
});

const GROUPS_PLACEHOLDER: TextAreaDefinition = buildTextAreaDefinition({
    name: "groups_placeholder",
    id: "noGroupsSelectedPlaceholder",
    text: `To assign a terminal group or group of games to a progressive, please define your preferences at jackpot groups section.`,
    label: "Groups",
    disabled: true,
    fieldOverrides: {
        columnClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 empty-groups"
    }
});

const PRIZE_PARAMETERS_GROUP: GroupDefinition = buildGroupDefinition({
    label: "Prize Parameters",
    id: "prizeParametersGroup",
    name: "prize_parameters_group"
});

const TIME_PARAMETERS_GROUP: GroupDefinition = buildGroupDefinition({
    label: "Time Parameters",
    id: "timeParametersGroup",
    name: "time_parameters_group"
});

const SECURITY_PARAMETERS_GROUP: GroupDefinition = buildGroupDefinition({
    label: "Security Parameters",
    id: "securityParametersGroup",
    name: "security_parameters_group"
});

const NOTICE_PERIOD: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "notice_period",
        id: "noticePeriod",
        label: "Notice period",
        placeholder: "Notice period",
        schemaName: SCHEMA_NAMES.NOTICE_PERIOD
    }
);

const COUNT_DOWN_PERIOD: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "count_down_period",
        id: "countDownPeriod",
        label: "Countdown Period",
        placeholder: "Countdown Period",
        schemaName: SCHEMA_NAMES.COUNT_DOWN_PERIOD
    }
);

const PROGRESSIVE_PRESET: (
    items: { label: string | number; value: string | number }[]
) => SelectMenuDefinition = items =>
    buildSelectMenuDefinition({
        name: "preset",
        id: "proportional_preset",
        label: "Preset",
        noValueLabel: "Choose a Preset...",
        items: items,
        schemaName: SCHEMA_NAMES.PRESET
    });

export function mrChampionFormDefinition(
    groupType: GROUP_TYPE,
    fullGroupList?: { label: string | number; value: string | number }[],
    selectedGroupList?: { label: string | number; value: string | number }[],
    presets?: { label: string | number; value: string | number }[],
): FormDefinition {
    return {
        [SCHEMA_NAMES.ID]: {
            definition: {
                ...ID,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                }
            },
            order: 0,
            inherited: true
        },
        [SCHEMA_NAMES.PRESET]: {
            definition: {
                ...PROGRESSIVE_PRESET(presets),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.PRIZE_PARAMETERS_GROUP]: {
            definition: {
                ...PRIZE_PARAMETERS_GROUP
            },
            order: 2
        },
        [SCHEMA_NAMES.MINIMUM_PLAYERS]: {
            definition: {
                ...MINIMUM_PLAYERS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                }
            },
            order: 3
        },
        [SCHEMA_NAMES.INITIAL_VALUE]: {
            definition: {
                ...INITIAL_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 3
        },
        [SCHEMA_NAMES.MAX_VALUE]: {
            definition: {
                ...MAX_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 4
        },
        [SCHEMA_NAMES.CONTRIBUTION]: {
            definition: {
                ...CONTRIBUTION,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 5
        },
        [SCHEMA_NAMES.MINIMUM_SORT]: {
            definition: {
                ...MINIMUM_SORT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 6
        },
        [SCHEMA_NAMES.MAXIMUM_SORT]: {
            definition: {
                ...MAXIMUM_SORT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 7
        },
        [SCHEMA_NAMES.TIME_PARAMETERS_GROUP]: {
            definition: {
                ...TIME_PARAMETERS_GROUP
            },
            order: 8
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_GAME]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_GAME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 9
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_EXTRA]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_EXTRA,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 10
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_BONUS]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_BONUS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 11
        },
        [SCHEMA_NAMES.NOTICE_PERIOD]: {
            definition: {
                ...NOTICE_PERIOD,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 12
        },
        [SCHEMA_NAMES.COUNT_DOWN_PERIOD]: {
            definition: {
                ...COUNT_DOWN_PERIOD,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 13
        },
        [SCHEMA_NAMES.SECURITY_PARAMETERS_GROUP]: {
            definition: {
                ...SECURITY_PARAMETERS_GROUP
            },
            order: 14
        },
        [SCHEMA_NAMES.WEIGHT_COIN_IN]: {
            definition: {
                ...WEIGHT_COIN_IN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 15
        },
        [SCHEMA_NAMES.PERCENTAGE_TERMINAL]: {
            definition: {
                ...PERCENTAGE_TERMINAL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 16
        },
        [SCHEMA_NAMES.WEIGHT_TOTAL_BONUS_WIN]: {
            definition: {
                ...WEIGHT_TOTAL_BONUS_WIN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 17
        },
        [SCHEMA_NAMES.HUNTER_DRAW_NO_WIN]: {
            definition: {
                ...HUNTER_DRAW_NO_WIN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 18
        },
        ...(groupType === GROUP_TYPE.TERMINAL && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...TERMINAL_GROUPS(selectedGroupList, fullGroupList),
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 1
            }
        }),
        ...(groupType === GROUP_TYPE.GAME && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...GAME_GROUPS(selectedGroupList, fullGroupList),
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 1
            }
        }),
        ...(![GROUP_TYPE.TERMINAL, GROUP_TYPE.GAME].includes(groupType) && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...GROUPS_PLACEHOLDER,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 1
            }
        })
    };
}

export function pigBoomFormDefinition(
    groupType: GROUP_TYPE,
    fullGroupList?: { label: string | number; value: string | number }[],
    selectedGroupList?: { label: string | number; value: string | number }[],
    presets?: { label: string | number; value: string | number }[],
): FormDefinition {
    return {
        [SCHEMA_NAMES.ID]: {
            definition: {
                ...ID,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                }
            },
            order: 0,
            inherited: true
        },
        [SCHEMA_NAMES.PRESET]: {
            definition: {
                ...PROGRESSIVE_PRESET(presets),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.BONUS_ENABLE_SCREEN]: {
            definition: {
                ...BONUS_ENABLE_SCREEN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.PRIZE_PARAMETERS_GROUP]: {
            definition: {
                ...PRIZE_PARAMETERS_GROUP
            },
            order: 3
        },
        [SCHEMA_NAMES.MINIMUM_PLAYERS]: {
            definition: {
                ...MINIMUM_PLAYERS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                }
            },
            order: 4
        },
        [SCHEMA_NAMES.CONTRIBUTION]: {
            definition: {
                ...CONTRIBUTION,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 4
        },
        [SCHEMA_NAMES.START_PERCENTAGE]: {
            definition: {
                ...START_PERCENTAGE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 5
        },
        [SCHEMA_NAMES.PRIZE_GOLD_VALUE]: {
            definition: {
                ...PRIZE_GOLD_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 6
        },
        [SCHEMA_NAMES.PRIZE_SILVER_VALUE]: {
            definition: {
                ...PRIZE_SILVER_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 7
        },
        [SCHEMA_NAMES.PRIZE_BRONZE_VALUE]: {
            definition: {
                ...PRIZE_BRONZE_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 8
        },
        [SCHEMA_NAMES.PRIZE_GOLD_FREQUENCY]: {
            definition: {
                ...PRIZE_GOLD_FREQUENCY,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 9
        },
        [SCHEMA_NAMES.PRIZE_SILVER_FREQUENCY]: {
            definition: {
                ...PRIZE_SILVER_FREQUENCY,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 10
        },
        [SCHEMA_NAMES.PRIZE_BRONZE_FREQUENCY]: {
            definition: {
                ...PRIZE_BRONZE_FREQUENCY,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 11
        },
        [SCHEMA_NAMES.TIME_PARAMETERS_GROUP]: {
            definition: {
                ...TIME_PARAMETERS_GROUP
            },
            order: 12
        },
        [SCHEMA_NAMES.TIME_WAIT_VIDEO]: {
            definition: {
                ...TIME_WAIT_VIDEO,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 13
        },
        [SCHEMA_NAMES.POP_TIME]: {
            definition: {
                ...POP_TIME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 14
        },
        [SCHEMA_NAMES.MINIMUM_POP_TIME]: {
            definition: {
                ...MINIMUM_POP_TIME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 15
        },
        [SCHEMA_NAMES.TIME_ELIGIBLE]: {
            definition: {
                ...TIME_ELIGIBLE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 16
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_BONUS]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_BONUS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 17
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_GAME]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_GAME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 18
        },
        [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_EXTRA]: {
            definition: {
                ...TIME_CONTINUE_ELIGIBLE_EXTRA,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time"
                },
                disabled:true
            },
            order: 19
        },
        [SCHEMA_NAMES.SHOW_ELIGIBLE_BONUS_ICON]: {
            definition: {
                ...SHOW_ELIGIBLE_BONUS_ICON,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 20
        },
        [SCHEMA_NAMES.SECURITY_PARAMETERS_GROUP]: {
            definition: {
                ...SECURITY_PARAMETERS_GROUP
            },
            order: 21
        },
        [SCHEMA_NAMES.WEIGHT_COIN_IN]: {
            definition: {
                ...WEIGHT_COIN_IN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 22
        },
        [SCHEMA_NAMES.PERCENTAGE_TERMINAL]: {
            definition: {
                ...PERCENTAGE_TERMINAL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage"
                },
                disabled:true
            },
            order: 23
        },
        [SCHEMA_NAMES.WEIGHT_TOTAL_BONUS_WIN]: {
            definition: {
                ...WEIGHT_TOTAL_BONUS_WIN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 24
        },
        [SCHEMA_NAMES.NUMBER_ELIGIBLE_GAMES]: {
            definition: {
                ...NUMBER_ELIGIBLE_GAMES,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 25
        },
        [SCHEMA_NAMES.HUNTER_DRAW_NO_WIN]: {
            definition: {
                ...HUNTER_DRAW_NO_WIN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                },
                disabled:true
            },
            order: 26
        },
        ...(groupType === GROUP_TYPE.TERMINAL && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...TERMINAL_GROUPS(selectedGroupList, fullGroupList),
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 2
            }
        }),
        ...(groupType === GROUP_TYPE.GAME && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...GAME_GROUPS(selectedGroupList, fullGroupList),
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 2
            }
        }),
        ...(![GROUP_TYPE.TERMINAL, GROUP_TYPE.GAME].includes(groupType) && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: {
                    ...GROUPS_PLACEHOLDER,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 2
            }
        }),
    };
}

export const SPECIAL_PRIZES_FIELD_NAMES = {
    type: "Type",
    [SCHEMA_NAMES.TERMINAL_GROUPS]: "Terminal Groups",
    [SCHEMA_NAMES.GAME_GROUPS]: "Game Groups",
    [SCHEMA_NAMES.INITIAL_VALUE]: "Initial Value",
    [SCHEMA_NAMES.MAX_VALUE]: "Maximum Value",
    [SCHEMA_NAMES.CONTRIBUTION]: "Contribution",
    [SCHEMA_NAMES.MINIMUM_PLAYERS]: "Min. Players",
    [SCHEMA_NAMES.MINIMUM_SORT]: "Min. Sort",
    [SCHEMA_NAMES.MAXIMUM_SORT]: "Max. Sort",
    [SCHEMA_NAMES.WEIGHT_COIN_IN]: "Weight Coin In",
    [SCHEMA_NAMES.WEIGHT_TOTAL_BONUS_WIN]: "Weight Total Bonus Win",
    [SCHEMA_NAMES.PERCENTAGE_TERMINAL]: "Percentage Terminal",
    [SCHEMA_NAMES.HUNTER_DRAW_NO_WIN]: "Hunter Draw No Win",
    [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_GAME]: "Time Continue Eligible Game",
    [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_BONUS]: "Time Continue Eligible Bonus",
    [SCHEMA_NAMES.TIME_CONTINUE_ELIGIBLE_EXTRA]: "Time Continue Eligible Extra",
    [SCHEMA_NAMES.SHOW_ELIGIBLE_BONUS_ICON]: "Show Eligible Bonus Icon",
    [SCHEMA_NAMES.BONUS_ENABLE_SCREEN]: "Toggle on Screen",
    [SCHEMA_NAMES.START_PERCENTAGE]: "Start Percentage",
    [SCHEMA_NAMES.PRIZE_GOLD_VALUE]: "Prize Gold value",
    [SCHEMA_NAMES.PRIZE_SILVER_VALUE]: "Prize Silver Value",
    [SCHEMA_NAMES.PRIZE_BRONZE_VALUE]: "Prize Bronze Value",
    [SCHEMA_NAMES.PRIZE_GOLD_FREQUENCY]: "Prize Gold Frequency",
    [SCHEMA_NAMES.PRIZE_SILVER_FREQUENCY]: "Prize Silver Frequency",
    [SCHEMA_NAMES.PRIZE_BRONZE_FREQUENCY]: "Prize Bronze Frequency",
    [SCHEMA_NAMES.NUMBER_ELIGIBLE_GAMES]: "Number Eligible Games",
    [SCHEMA_NAMES.TIME_ELIGIBLE]: "Time Eligible",
    [SCHEMA_NAMES.POP_TIME]: "Pop Time",
    [SCHEMA_NAMES.MINIMUM_POP_TIME]: "Minimum Pop Time",
    [SCHEMA_NAMES.TIME_WAIT_VIDEO]: "Time Wait Video"
};
